let initialized = false;
export function initRemoteLogger() {
    if (initialized)
        return;
    initialized = true;
    const params = new URLSearchParams(window.location.search);
    const endpoint = params.get('remoteLog');
    if (!endpoint)
        return;
    const sessionId = params.get('debugSessionId') ?? undefined;
    const origLog = console.log;
    const origWarn = console.warn;
    const origError = console.error;
    const headers = {
        'Content-Type': 'application/json',
    };
    if (sessionId) {
        headers['X-Debug-Session-Id'] = sessionId;
    }
    const send = (level, args) => {
        const message = args
            .map((a) => {
            if (typeof a === 'string')
                return a;
            try {
                return JSON.stringify(a);
            }
            catch {
                return String(a);
            }
        })
            .join(' ');
        const body = {
            level,
            message,
            timestamp: Date.now(),
            location: 'iPhone',
        };
        if (sessionId) {
            body.sessionId = sessionId;
        }
        fetch(endpoint, {
            method: 'POST',
            headers,
            body: JSON.stringify(body),
            keepalive: true,
        }).catch(() => { });
    };
    console.log = (...args) => {
        origLog.apply(console, args);
        send('log', args);
    };
    console.warn = (...args) => {
        origWarn.apply(console, args);
        send('warn', args);
    };
    console.error = (...args) => {
        origError.apply(console, args);
        send('error', args);
    };
    window.addEventListener('error', (event) => {
        send('error', [
            `Uncaught ${event.error?.stack ?? event.message} at ${event.filename}:${event.lineno}`,
        ]);
    });
    window.addEventListener('unhandledrejection', (event) => {
        send('error', [
            `Unhandled rejection: ${event.reason?.stack ?? event.reason}`,
        ]);
    });
    origLog('[remoteLogger] Sending logs to', endpoint);
}
